// File: frontend/src/views/private/admin/QMS.js

import React from 'react';
import AdminPageTemplate from '../../../components/layout/AdminPageTemplate';
import { FileBarChart } from 'lucide-react';

const QMS = () => {
  return (
    <AdminPageTemplate
      title="Quote Management System"
      subtitle="Create, manage, and track insurance quotes"
      icon={FileBarChart}
      showComingSoon={true}
    />
  );
};

export default QMS;